import lazuliskirt from "../../image/flirty-lazuli/lazuliskirt.webp";

import Items from './Item'

const Shop = () => {

  const items = [
    {
      id: "102",
      name: "Flirty Lazuli Skirt",
      image: lazuliskirt,
      price: "$145",
      thumbnails: [lazuliskirt],
      description:
        "With black RT monogram on baby blue with neon seam.  95% poly 5% spandex (feels like silk on your skin)  Designed in UK, Made in Los Angeles.  The color may vary due to lighting on the images. The product images (without models) are closest to the true color of the product Hand wash cold and hang dry.",
      projectUrl:
        "",
      sizes: ["Small", "Medium", "Large", "XLarge"],
    },
  ];

  return (
    <Items items={items} />
  )
}

export default Shop;
